import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    modalStatus: false,
    selectedUser: null,
    isSignedIn: false,
    isLoginDialogOpen: false,
    isRegisterDialogOpen: false,
    UserPageOpen: false,
    deletePageOpen: false,
    status: null,
    selectedUser: null,
    selectedUserRole: null,
    isAdmin: false,
    profileEditFormOpen: false,
    addressEditFormOpen: false,
  },
  reducers: {
    openAddUserModal: (state) => {
      state.modalStatus = "add";
    },
    openEditUserModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedUser = action.payload;
    },
    openDeleteUserModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedUser = action.payload;
    },
    closeUserModal: (state) => {
      state.modalStatus = false;
      state.selectedUser = null;
    },
    login: (state, action) => {
      const { access_token, details, role } = action.payload;
      // sessionStorage.setItem("access_token", access_token);
      Object.assign(state, {
        isSignedIn: true,
        isLoginDialogOpen: false,
        details,
      });
    },
    logout: (state) => {
      sessionStorage.removeItem("access_token");
      state.isSignedIn = false;
      delete state.details;
      // state.isHomePageOpen = !state.isHomePageOpen;
    },
    toggleLoginDialog: (state) => {
        console.log('toggleLoginDialog called');

      state.isLoginDialogOpen = !state.isLoginDialogOpen;
    },
    toggleRegisterDialog: (state) => {
      console.log("toggleRegisterDialog called");

      state.isRegisterDialogOpen = !state.isRegisterDialogOpen;
    },
    openUserForm: (state, action) => {
      state.UserPageOpen = action.payload;
    },

    openDeletePage: (state, action) => {
      state.deletePageOpen = action.payload;
    },

    setStatus: (state, action) => {
      state.status = action.payload;
    },

    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },

    setSelectedUserRole: (state, action) => {
      state.selectedUserRole = action.payload;
    },

    openEditProfileForm: (state, action) => {
      state.profileEditFormOpen = action.payload;
    },
    openEditAddressForm: (state, action) => {
      state.addressEditFormOpen = action.payload;
    },
  },
});

export const {
  openAddUserModal,
  openEditUserModal,
  openDeleteUserModal,
  closeUserModal,
  login,
  logout,
  toggleLoginDialog,
  toggleRegisterDialog,
  openUserForm,
  openDeletePage,
  setSelectedUser,
  setSelectedUserRole,
  setStatus,
  openEditProfileForm,
} = userSlice.actions;
export const selectUser = (state) => state.user;

export default userSlice.reducer;
